module.exports = __webpack_public_path__ + "static/media/arrow-long.70afb22a.svg";